import { render, staticRenderFns } from "./ReportGraph.vue?vue&type=template&id=a2a13cf4&scoped=true&"
import script from "./ReportGraph.vue?vue&type=script&lang=js&"
export * from "./ReportGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a13cf4",
  null
  
)

export default component.exports